<template>
  <path
    d="M5 18.0002H6C6.55 18.0002 7 17.5502 7 17.0002V6.00024C7 5.45024 6.55 5.00024 6 5.00024H5C4.45 5.00024 4 5.45024 4 6.00024V17.0002C4 17.5502 4.45 18.0002 5 18.0002ZM18 6.00024V17.0002C18 17.5502 18.45 18.0002 19 18.0002H20C20.55 18.0002 21 17.5502 21 17.0002V6.00024C21 5.45024 20.55 5.00024 20 5.00024H19C18.45 5.00024 18 5.45024 18 6.00024ZM9 18.0002H16C16.55 18.0002 17 17.5502 17 17.0002V6.00024C17 5.45024 16.55 5.00024 16 5.00024H9C8.45 5.00024 8 5.45024 8 6.00024V17.0002C8 17.5502 8.45 18.0002 9 18.0002Z"
  />
</template>
